<template>
  <div
    class="mt-2 question-content"
    v-html="question.content"
  />
</template>
<script>

export default {
  props: {
    question: {
      type: Object,
      required: true,
    }
  },
}
</script>
<style lang="scss">
.question-content{
  img{
    max-width: 100%;
    width: 100%;
  }
}
</style>
